import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/hr.png'


const _withScopeId = n => (_pushScopeId("data-v-1cc9dd0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "welfare bx" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createTextVNode(" 一起参加公益 "),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, " 最近连续在体育频道看见跑鞋的广告，忽然间意识到，跑步这项运动火了。几年前曾经有这样的论调，当人均GDP达到8000美元的时候，马拉松运动将以井喷的势态呈现，关注一下经济状况与跑步活动的频度，显然我们还没有达到预期井喷的收入，但确实已经有了一窝蜂的跑步赛事，仅仅2012这一年里,国内各地区举办马拉松的城市就翻了一番，新增马拉松人口呈几何增长，这与人们逐步意识到跑步的社会价值密不可分。跑步，就是做公益。 ", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://img1.baidu.com/it/u=630484063,1199634070&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=752",
    style: {"width":"100%","height":"100%"}
  })
], -1))
const _hoisted_7 = { class: "right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-title" }, "“跑步就是做公益”", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-content" }, " 企业本身就是一个经济体，影响力远远大于个体，公司的群体氛围也可以给一些未能主动跑步的人一些激励，导向良性循环中。优秀的企业早就知道，员工花时间投入在健康上，绝不会浪费公司的资源，反而会给公司带来更大的价值。 ", -1))
const _hoisted_10 = { class: "btn-box" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://img1.baidu.com/it/u=630484063,1199634070&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=752",
    style: {"width":"100%","height":"100%"}
  })
], -1))
const _hoisted_13 = { class: "right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-title" }, "“健康需要管理”", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-content" }, " 倡导全民运动、全民健身，养成运动良好习惯，通过跑步传递上进的力量，让身边的人一起感受运动通过跑步传递上进的力量… ", -1))
const _hoisted_16 = { class: "btn-box" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic.jkjianfei.com%2Fjianfei_images%2Fnhphghnv.jpeg&refer=http%3A%2F%2Fpic.jkjianfei.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1647161454&t=ec05c1e66fd14649fd9a7db5f71624c6",
    style: {"width":"100%","height":"100%"}
  })
], -1))
const _hoisted_19 = { class: "right" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-title" }, "“企业是跑步的最佳载体”", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-content" }, " 最近连续在体育频道看见跑鞋的广告，忽然间意识到，跑步这项运动火了。几年前曾经有这样的论调，当人均GDP达到8000美元的时候，马拉松运动将以井喷的势态呈现，关注一下经济状况与跑步活动的频度，显然我们还没有达到预期井喷的收入，但确实已经有了一窝蜂的跑步赛事，仅仅2012这一年里，国内各地区举办马拉松的城市就翻了一番，新增马拉松人口呈几何增长，这与人们逐步意识到跑步的社会价值密不可分。跑步，就是做公益。 ", -1))
const _hoisted_22 = { class: "btn-box" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://img0.baidu.com/it/u=2714902772,1233776750&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=687",
    style: {"width":"100%","height":"100%"}
  })
], -1))
const _hoisted_25 = { class: "right" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-title" }, "“健康守护者”", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-content" }, " 身体健康之外，运动对心理健康的价值更大，比如长跑在治疗抑郁方面有非常显著的效果，同时也是历练身心、缓解压力的良好途径。健康说到底无非平衡二字，肌肉力量平衡、营养平衡、工作生活中积累压力与释放排解的平衡。所谓和谐，不也是大环境下的相对平衡吗，这就是社会的健康。 ", -1))
const _hoisted_28 = { class: "btn-box" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import LoginToast from '@/components/loginToast.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const showLogin = ref(false);

const toArticle = (id: any) => {
  router.push({
    name: 'article',
    query: {
      articleId: id
    }
  });
};

const toDetail = () => {
  if (window.localStorage.getItem('authToken')) {
    router.push({
      name: 'welfareActivity',
      query: {
        welfareType: 3
      }
    });
  } else {
    showLogin.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toArticle('34')))
            }, "了解详情"),
            _createElementVNode("div", {
              class: "btn join",
              onClick: toDetail
            }, "我要参与")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toArticle('36')))
            }, "了解详情"),
            _createElementVNode("div", {
              class: "btn join",
              onClick: toDetail
            }, "我要参与")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: "btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (toArticle('37')))
            }, "了解详情")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", {
              class: "btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (toArticle('38')))
            }, "了解详情")
          ])
        ])
      ])
    ]),
    _createVNode(LoginToast, {
      showLogin: showLogin.value,
      "onUpdate:confirm": _cache[4] || (_cache[4] = ($event: any) => (showLogin.value = false))
    }, null, 8, ["showLogin"])
  ]))
}
}

})